var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69997 1.67773H6.29997C5.09997 1.67773 4.83331 2.27774 4.67997 3.01774L4.1333 5.63106H11.8666L11.32 3.01774C11.1666 2.27774 10.9 1.67773 9.69997 1.67773Z",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8269 9.89168C12.8802 10.4583 12.4269 10.945 11.8469 10.945H10.9402C10.4202 10.945 10.3469 10.725 10.2535 10.445L10.1535 10.1583C10.0202 9.76499 9.93354 9.49833 9.23354 9.49833H6.7602C6.06687 9.49833 5.9602 9.79833 5.8402 10.1583L5.7402 10.445C5.64687 10.7184 5.57353 10.945 5.05353 10.945H4.14687C3.56687 10.945 3.11353 10.4583 3.16687 9.89168L3.4402 6.94503C3.50687 6.21836 3.64686 5.625 4.91353 5.625H11.0802C12.3469 5.625 12.4869 6.21836 12.5535 6.94503L12.8269 9.89168Z",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13364 4.17773H3.64697",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3534 4.17773H11.8667",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1001 7.56445H6.54677",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45361 7.56445H10.9003",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6777V12.3444",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.3438V15.0104",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00016 12.3438L1.3335 15.0104",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.3438L14.6667 15.0104",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.c8aa7a4b934c5811c9d4a952a71aa061.svg";
export { ForwardRef as ReactComponent };